export const heroStats = [
  { id: 1, value: '96+', label: 'Projects Done' },
  { id: 2, value: '190+', label: 'Happy Clients' },
  { id: 3, value: '40+', label: 'Tech Partners' },
  { id: 4, value: '10+', label: 'Years Expertise' }
];

export const mainServices = [
  {
    id: 1,
    title: 'Enterprise Networks',
    subtitle: 'LAN · WAN · Wireless',
    icon: 'Network'
  },
  {
    id: 2,
    title: 'Cloud Solutions',
    subtitle: 'AWS · Azure · Private',
    icon: 'Cloud'
  },
  {
    id: 3,
    title: 'Endpoint Security',
    subtitle: 'EPP · EDR · SIEM',
    icon: 'Shield'
  },
  {
    id: 4,
    title: 'IT Hardware',
    subtitle: 'Laptops · Servers · NAS',
    icon: 'Laptop'
  }
];

export const whatWeDo = [
  {
    id: 1,
    icon: 'Network',
    title: 'Enterprise Networks',
    description: 'Connecting businesses through integrated data, voice, wired, and wireless solutions while securing the network perimeter and endpoints.'
  },
  {
    id: 2,
    icon: 'Cloud',
    title: 'Data Centre & Cloud',
    description: 'Scalable, flexible, and cost-efficient cloud and data centre solutions to store, manage, and deliver data and applications seamlessly.'
  },
  {
    id: 3,
    icon: 'Shield',
    title: 'Endpoint Protection',
    description: 'Safeguard devices from cyber threats with robust EPP/EPS solutions against malware, ransomware, and advanced persistent attacks.'
  },
  {
    id: 4,
    icon: 'Laptop',
    title: 'IT Hardware',
    description: 'Powerful computing solutions — laptops, desktops, servers, and peripherals from top brands for individuals and enterprises.'
  }
];

export const products = [
  { id: 1, title: 'Laptops & Desktops', subtitle: 'Business & consumer grade', icon: 'Laptop' },
  { id: 2, title: 'Computer Components', subtitle: 'Processors, RAM, storage', icon: 'Cpu' },
  { id: 3, title: 'CCTV & Security Systems', subtitle: 'IP cameras, NVR/DVR', icon: 'Camera' },
  { id: 4, title: 'Network Equipment', subtitle: 'Switches, routers, APs', icon: 'Wifi' },
  { id: 5, title: 'Software & Licenses', subtitle: 'OS, productivity, security', icon: 'Package' },
  { id: 6, title: 'Smart Home & IoT', subtitle: 'Automation & connectivity', icon: 'Home' },
  { id: 7, title: 'Servers & Data Storage', subtitle: 'NAS, SAN, rack servers', icon: 'Server' },
  { id: 8, title: 'Accessories & Peripherals', subtitle: 'Keyboards, mice, docks', icon: 'Mouse' }
];

export const services = [
  {
    id: 1,
    icon: 'Headphones',
    title: 'IT Consulting & Support',
    description: 'Expert guidance and round-the-clock technical support for your IT infrastructure.'
  },
  {
    id: 2,
    icon: 'Settings',
    title: 'AMC Services',
    description: 'Annual maintenance contracts for maximum uptime and predictable IT costs.'
  },
  {
    id: 3,
    icon: 'Camera',
    title: 'CCTV & Security',
    description: 'End-to-end surveillance design, installation, and monitoring solutions.'
  },
  {
    id: 4,
    icon: 'Wifi',
    title: 'Networking & Internet',
    description: 'High-speed, reliable networking and internet connectivity for businesses.'
  },
  {
    id: 5,
    icon: 'Code',
    title: 'Web Design & Development',
    description: 'Modern, responsive websites and web applications built for results.'
  },
  {
    id: 6,
    icon: 'Cloud',
    title: 'Cloud Hosting Services',
    description: 'Managed cloud hosting with guaranteed uptime, security, and scalability.'
  },
  {
    id: 7,
    icon: 'HardDrive',
    title: 'IT H/W & S/W Installations',
    description: 'Professional hardware and software installation, configuration, and migration.'
  },
  {
    id: 8,
    icon: 'Server',
    title: 'Server Management',
    description: 'Proactive server monitoring, management, and virtualization services.'
  }
];

export const solutions = [
  {
    id: 1,
    icon: 'Shield',
    title: 'Endpoint Protection',
    description: 'Comprehensive EPP/EDR solutions to protect every device in your organization.'
  },
  {
    id: 2,
    icon: 'Smartphone',
    title: 'Mobile Device Management',
    description: 'Centrally manage and secure all mobile devices across your enterprise.'
  },
  {
    id: 3,
    icon: 'Database',
    title: 'Backup Solutions',
    description: 'Automated, tested, and reliable backup strategies to protect critical data.'
  },
  {
    id: 4,
    icon: 'Lock',
    title: 'Data Loss Prevention (DLP)',
    description: 'Prevent unauthorized data exfiltration and ensure regulatory compliance.'
  },
  {
    id: 5,
    icon: 'Cloud',
    title: 'Data Centre & Cloud',
    description: 'Hybrid and multi-cloud solutions tailored to your performance and budget goals.'
  },
  {
    id: 6,
    icon: 'Users',
    title: 'CRM Solutions',
    description: 'Customer relationship management platforms to streamline sales and support.'
  },
  {
    id: 7,
    icon: 'HardDrive',
    title: 'Network & Storage Solutions',
    description: 'High-performance network infrastructure and scalable storage architectures.'
  },
  {
    id: 8,
    icon: 'Fingerprint',
    title: 'Biometric & Attendance',
    description: 'Advanced biometric systems for precise workforce attendance management.'
  }
];

export const partners = [
  'AccOps', 'Acer', 'Acronis', 'Amazon AWS', 'Aruba Networks', 'Check Point',
  'Cisco', 'Dell Technologies', 'ESET', 'Everest', 'Fortinet', 'Google Cloud',
  'HP', 'Kaspersky', 'Lenovo', 'McAfee', 'Microsoft', 'Microsoft Azure',
  'Prophaze', 'QNAP', 'Quantum', 'Ruckus', 'Safetica', 'Seceon',
  'Sify', 'SonicWall', 'Sophos', 'SOTI', 'Synology', 'Tenable',
  'Trellix', 'Veeam', 'Veritas', 'Zoho'
];

export const impactStats = [
  { id: 1, icon: 'FolderCheck', value: 51, suffix: '+', label: 'Projects Completed', subtitle: 'Successfully delivered across industries' },
  { id: 2, icon: 'SmilePlus', value: 101, suffix: '+', label: 'Happy Customers', subtitle: 'Businesses trusting R-Technos' },
  { id: 3, icon: 'Users', value: 6, suffix: '', label: 'Experienced Staff', subtitle: 'Certified IT professionals' },
  { id: 4, icon: 'TrendingUp', value: 5, suffix: '+', label: 'Ongoing Projects', subtitle: 'Active partnerships growing' }
];

export const ctaFeatures = [
  { id: 1, icon: 'MessageCircle', title: 'Free Consultation' },
  { id: 2, icon: 'Award', title: 'Certified Engineers' },
  { id: 3, icon: 'Clock', title: '24/7 Support' },
  { id: 4, icon: 'CheckCircle', title: 'SLA Guarantee' }
];